<template>
  <Flex :direction="'column'">
    <BaseText center>
      {{ $t('verification.description') }}
    </BaseText>
    <BaseForm @submit="requestCode">
      <Flex :direction="'column'">
        <BaseDropdown
          v-model="country"
          :options="
            countries.map((country) => ({
              value: country.code,
              label: country.name
            }))
          "
          :label="$t('global.country')"
          searchable
          v-test="'verification-country'"
        />
        <BaseInput
          v-model="phoneNumber"
          :label="$t('global.mobile_number')"
          type="text"
          name="phoneNumber"
          required
          :error="phoneNumberError"
          v-test="'verification-number'"
        />
        <BaseText
          v-if="tokenError"
          color="error"
        >
          {{ tokenError }}
        </BaseText>
        <div :class="$style.bottom">
          <BaseButton
            :loading="isLoading"
            center
            submitForm
            v-test="'verification-submit'"
          >
            {{ $t('verification.send_code') }}
          </BaseButton>
        </div>
      </Flex>
    </BaseForm>
  </Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from '@/axios';
import prefixes from '@/phone-prefixes';
import { useCompanyStore } from '@/stores/company';

export default defineComponent({
  emits: ['textSent'],
  data() {
    const { company } = useCompanyStore();
    return {
      phoneNumber: null,
      country: company?.country || null,
      isLoading: false,
      countries: prefixes,
      phoneNumberError: '',
      tokenError: '',
    };
  },
  computed: {
    phonePrefix() {
      return this.countries.find((country) => country.code === this.country)
        .prefix;
    },
  },
  methods: {
    requestCode() {
      this.isLoading = true;
      axios
        .post('/verifications', {
          phone_prefix: this.phonePrefix.toString(),
          phone_number: this.phoneNumber,
        })
        .then(() => {
          this.$emit('textSent');
        })
        .catch((response) => {
          if (response?.errors) {
            this.phoneNumberError = this.$t('verification.phone_error');
          } else {
            this.tokenError = this.$t('verification.token_info');
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.bottom {
  text-align: center;
}
</style>
